module.exports = __webpack_public_path__ + "assets/ic-bitcoinist.50790368.svg";